import request from '@/utils/request'
export function getVideos(query) {
    return request({
        url: "/videoInfo/list",
        method: "get",
        params: query,
    });
}

//   ?pageNum=1&pageSize=10&type=首页广告位6